<div
    class="input-wrapper"
    [class.secondary]="semantic === SECONDARY && focus"
    [class.tertiary]="semantic === TERTIARY && focus"
    [class.error]="inputValueCheck === ERROR"
    [class.selecting-error]="inputValueCheck === ERROR && focus">
    <input
        [name]="name"
        [(ngModel)]="inputValue"
        (ngModelChange)="onChange($event)"
        [placeholder]="label | translate"
        (focus)="inputFocus()"
        (blur)="inputBlur()"
        (keydown)="inputKeyDown($event)"
        (wheel)="$event.preventDefault()"
        [ngClass]="{
            'weight-medium': weight === MEDIUM,
            'weight-regular': weight === REGULAR,
            'weight-bold': weight === BOLD,
            'weight-semi-bold': weight === SEMIBOLD,
        }"
        data-cy="ops-settings-system-setting-modal-text-field"
        [maxLength]="maxLength" />
    <p *ngIf="unit" class="unit">
        {{ unit }}
    </p>
</div>
<div
    class="helper-message"
    [class.secondary]="semantic === SECONDARY && focus"
    [class.tertiary]="semantic === TERTIARY && focus"
    [class.error]="inputValueCheck === ERROR"
    [class.selecting-error]="inputValueCheck === ERROR && focus"
    *ngIf="showErrorMessage || showLenCounter">
    <div *ngIf="showErrorMessage && inputValueCheck === ERROR">
        {{ getErrorString() }}
    </div>

    <div *ngIf="showLenCounter" class="counter-text">
        {{ (inputValue?.length ?? 0) + '/' + maxLength }}
    </div>
</div>
